import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'
import OperationType from '../../../../../../../containers/stocks/select/OperationType'
import { canRenderInputForType } from '../_helpers/hideInputForType'

const StockOperationTypeSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChange } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()

  const shouldRender = canRenderInputForType(selectedQuestion.questionType.name)
  const shouldRenderOption = shouldRender('stockOperationType')

  if (!shouldRenderOption) return false

  return (
    <>
      <Title size="h6" color={COLORS.dark4}>
        {t('operationType')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />
      <OperationType
        value={selectedQuestion.data?.stockOperationType}
        onChange={v => handleSelectedQuestionChange('data', { ...selectedQuestion.data, stockOperationType: v })}
      />
      <Separator weight={2} />
    </>
  )
}

export default StockOperationTypeSection
